import React, { useContext, useState } from "react";
import axios from "axios";
import { BASE_URL, UserContext } from "../contexts/UserContext";
import ButtonLoader from './../components/ButtonLoader';
import { useNavigate } from "react-router-dom";
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';


const CreatePost = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("Uncategorized");
  const [description, setDescription] = useState("");
  const [thumbnail, setThumbnail] = useState("");

  const [loading, setLoading] = useState(false)
  const { error, setError, setMessage } = useContext(UserContext)

  const navigate = useNavigate()
  const POST_CATEGORTIES = [
    "Uncategoize",
    "Agriclture",
    "Business",
    "Education",
    "Ebtertainment",
    "Art",
    "Investment",
    "Weather",
  ];

  const updateProfileDataChange = (e) => {
    setThumbnail(e.target.files[0])
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const myForm = new FormData();
      setLoading(true);
      myForm.append("title", title);
      myForm.append("description", description);
      myForm.append("photo", thumbnail);
      myForm.append("category", category);
      const { data } = await axios.post(
        `${BASE_URL}/posts/new/create`,
        myForm,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      setError(null);
      setMessage(data.message);
      navigate('/')
    } catch (error) {
      setError(error.response.data.message);

    } finally {
      setTitle("");
      setDescription("");
      setThumbnail("");
      setCategory("Uncategorized");
      setThumbnail("");
      setLoading(false)
    }
  };
;

  return (
    <section className="create-post">
      <div className="container">
        <h2>Create Post</h2>
        {
          error && <p className="form__error-message">
            This is an error message. Please try again
          </p>
        }
        <form className="form create-post__form" onSubmit={handleFormSubmit}>
          <input
            type="text"
            placeholder="Title"
            autoFocus
            onChange={(e) => setTitle(e.target.value)}
            value={title}
          />
          <select
            name="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            {POST_CATEGORTIES.map((cat) => (
              <option key={cat}>{cat}</option>
            ))}
          </select>
           <ReactQuill
            theme="snow"
            value={description}
            onChange={setDescription}
          /> 
          {/* <textarea
            placeholder="Description"
            value={description}
            style={{height: '10rem'}}
            onChange={(e) => setDescription(e.target.value)}
          /> */}
          <input
            type="file"
            onChange={(e) => updateProfileDataChange(e)}
            accept="png, jpg, jpeg"
          />
          <button type="submit" className="btn primary">
            {
              loading ? <ButtonLoader /> : "Create"
            }
          </button>
        </form>
      </div>
    </section>
  );
};

export default CreatePost;
